// Formatting helpers only: the server computes every event total, share and balance.

export const EVENT_CATEGORIES = [
  { value: 'hotel', label: '🏨 Hotel' },
  { value: 'transport', label: '🚗 Transport' },
  { value: 'activity', label: '🎟️ Activity' },
  { value: 'food', label: '🍔 Food' },
  { value: 'other', label: '📦 Other' },
];

export const PAYMENT_TYPES = [
  { value: 'ADVANCE', label: 'Advance' },
  { value: 'INSTALLMENT', label: 'Part payment' },
  { value: 'FINAL', label: 'Final payment' },
];

export const formatMoney = (value) => `₹${(Number(value) || 0).toFixed(2)}`;

export const categoryEmoji = (category) => {
  const match = EVENT_CATEGORIES.find((c) => c.value === category);
  return (match || EVENT_CATEGORIES[EVENT_CATEGORIES.length - 1]).label.split(' ')[0];
};

export const paymentTypeLabel = (type) => {
  const match = PAYMENT_TYPES.find((t) => t.value === type);
  return match ? match.label : type;
};

// Advance when nothing has been paid yet, final when the amount clears what is outstanding.
export const defaultPaymentType = (amount, paid, outstanding) => {
  const value = parseFloat(amount);
  if (!isNaN(value) && Math.abs(value - outstanding) < 0.01) return 'FINAL';
  return paid > 0 ? 'INSTALLMENT' : 'ADVANCE';
};

// The request body shape the events API expects for a line item's split.
export const toShareRequests = (splitType, selectedParticipants, exactAmounts) =>
  selectedParticipants.map((userId) => ({
    userId,
    amount: splitType === 'exact' ? parseFloat(exactAmounts[userId]) : null,
  }));

export const todayIso = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
};
